<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" [modal]="true"
  header="Assign Operational Capability" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(900px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
  styleClass="master-create-dialog">
  <section class="master-dialog-body">
    <aside class="master-dialog-summary">
      <div class="summary-icon"><i class="pi pi-award"></i></div>
      <div><small>Field Work</small><h3>Confirm a person's capability</h3>
        <p>Operational capability is maintained in Field Work and does not change the employee's HR learning record.</p></div>
      <div class="master-dialog-facts">
        <div><span>Field person</span><strong>{{ selectedWorker?.displayName || 'Select person' }}</strong></div>
        <div><span>Capability</span><strong>{{ form.fieldCapabilityId ? 'Selected' : 'Select capability' }}</strong></div>
      </div>
    </aside>

    <form class="master-dialog-form" (ngSubmit)="submit()">
      <div class="dialog-error master-wide-field" *ngIf="validationError || error">
        <i class="pi pi-exclamation-circle"></i><span>{{ validationError || error }}</span>
      </div>
      <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon><p-iftalabel>
        <p-autoComplete inputId="capabilityWorker" name="worker" [(ngModel)]="selectedWorker" [suggestions]="people"
          optionLabel="displayName" [dropdown]="true" [forceSelection]="true" appendTo="body" styleClass="w-full"
          (completeMethod)="searchWorkers($event.query)"></p-autoComplete>
        <label for="capabilityWorker">Field person *</label></p-iftalabel></p-inputGroup>
      <p-inputGroup><p-inputGroupAddon><i class="pi pi-star"></i></p-inputGroupAddon><p-iftalabel>
        <p-select inputId="capability" name="fieldCapabilityId" [(ngModel)]="form.fieldCapabilityId" [options]="capabilityOptions"
          optionLabel="label" optionValue="value" [filter]="true" appendTo="body" styleClass="w-full"></p-select>
        <label for="capability">Capability *</label></p-iftalabel></p-inputGroup>
      <p-inputGroup><p-inputGroupAddon><i class="pi pi-chart-line"></i></p-inputGroupAddon><p-iftalabel>
        <p-select inputId="capabilityProficiency" name="fieldProficiencyLevelId" [(ngModel)]="form.fieldProficiencyLevelId"
          [options]="proficiencyOptions" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
        <label for="capabilityProficiency">Proficiency *</label></p-iftalabel></p-inputGroup>
      <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftalabel>
        <p-datepicker inputId="capabilityExpiry" name="expiresOn" [(ngModel)]="form.expiresOn" dateFormat="yy-mm-dd"
          [showIcon]="true" [showButtonBar]="true" appendTo="body" styleClass="w-full"></p-datepicker>
        <label for="capabilityExpiry">Expires on</label></p-iftalabel></p-inputGroup>
    </form>
  </section>
  <ng-template pTemplate="footer"><div class="master-dialog-footer">
    <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="reset()"></p-button>
    <span class="footer-spacer"></span>
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" [disabled]="saving" (onClick)="close()"></p-button>
    <p-button label="Assign capability" icon="pi pi-award" [loading]="saving" (onClick)="submit()"></p-button>
  </div></ng-template>
</p-dialog>
